import type { Step } from "react-joyride";

export const meetingDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ສະແດງລາຍລະອຽດບັນທຶກການປະຊຸມ: ວັນທີ, ຫົວຂໍ້, ສະຫຼຸບ, ຜູ້ຮ່ວມ ແລະ ປະເດັນທີ່ລົມກັນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="meeting-detail-header"]',
    content:
      "ຫົວຂໍ້ ແລະ ປຸ່ມກັບຄືນ, ເບິ່ງ PDF, ປະເດັນ, ແກ້ໄຂ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="meeting-detail-content"]',
    content:
      "ເນື້ອໃນບັນທຶກການປະຊຸມ: ຂໍ້ມູນທົ່ວໄປ, ຜູ້ຮ່ວມ ແລະ ປະເດັນທີ່ລົມກັນ.",
    placement: "top",
  },
];
